
jQuery(document).ready(function ($) {
    "use strict";
    if ($(".tf-swiper").length > 0) {
        $(".tf-swiper").each(function () {
            const config = $(this).data("swiper");
            // if (config.loop === true && config.slidesPerGroup) {
            //   delete config.slidesPerGroup;
            // }
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
            new Swiper(this, config);
        });
    }


    if ($(".slideshow-v2").length > 0) {
        var main = new Swiper(".slideshow-v2-main", {
            slidesPerView: 1,
            freeMode: true,
            watchSlidesProgress: true,
            allowTouchMove: true,
            observer: true,
            observeParents: true,
            speed: 1000,
            effect: "fade",
            // creativeEffect: {
            //     prev: {
            //         shadow: !0,
            //         translate: [0, 0, -400]
            //     },
            //     next: {
            //         translate: ["100%", 0, 0]
            //     }
            // },
            // coverflowEffect: {
            //     rotate: 50,
            //     stretch: 0,
            //     depth: 100,
            //     modifier: 1,
            //     slideShadows: !0
            // }

        });

        var thumbs = new Swiper(".slideshow-v2-thumbs", {
            spaceBetween: 0,
            observer: true,
            observeParents: true,
            allowTouchMove: true,
            navigation: {
                nextEl: ".slideshow-v2-next",
                prevEl: ".slideshow-v2-prev",
            },
            pagination: {
                el: ".slideshow-v2-pagination",
                clickable: true,
            },
            thumbs: {
                swiper: main,
            },

            effect: "creative",
            speed: 1000,
            cardsEffect: {
                perSlideOffset: -60,
                perSlideRotate: 0,
                rotate: !1,
                slideShadows: !1
            },
            breakpoints: {
                0: {
                    creativeEffect: {
                        limitProgress: 1,
                        prev: {
                            translate: [-38, 0, 0],
                            scale: .82,
                        },
                        next: {
                            translate: [-38, 0, 0],
                            scale: .82,
                        }
                    },
                },
                767: {
                    creativeEffect: {
                        limitProgress: 1,
                        prev: {
                            translate: [-85, 0, 0],
                            scale: .82,
                        },
                        next: {
                            translate: [-85, 0, 0],
                            scale: .82,
                        }
                    },
                },
                992: {
                    creativeEffect: {
                        limitProgress: 1,
                        prev: {
                            translate: [-20, 0, 0],
                            scale: .82,
                        },
                        next: {
                            translate: [-50, 0, 0],
                            scale: .82,
                        }
                    },
                },
            },
        });
    }

})


